import React from 'react';
import { MOCKUP_IMAGE } from '../data/content';
export function Hero() {
  return <header className="relative overflow-hidden bg-blush/60 px-5 pb-10 pt-10 sm:px-8 lg:pb-14 lg:pt-14" data-id="element-58" data-mp="ek692vtesgbf">
      <div className="relative mx-auto flex w-full max-w-[820px] flex-col items-center text-center" data-id="element-59" data-mp="9ka5gxomiqwe">
        <h1 className="mx-auto max-w-[16ch] font-display text-[27px] font-bold uppercase leading-[1.16] tracking-[-0.01em] text-ink sm:max-w-[22ch] sm:text-[40px] lg:text-[50px]" data-id="element-60" data-mp="4m8m0bnacpke">
          <span className="text-coral" data-id="element-61" data-mp="xae6qyecaek8">7 días</span> para romper{' '}
          <span className="text-coral" data-id="element-62" data-mp="xb5r1d2hkpv7">10 creencias</span> que te hicieron creer
          que tu cuerpo tenía que cambiar para que pudieras{' '}
          <span className="text-coral" data-id="element-63" data-mp="ncq0bb7dfim8">
            sentirte suficiente, aceptado/a y libre
          </span>
        </h1>

        <div className="relative mt-7 flex w-full justify-center" data-id="element-64" data-mp="3d2l95b1th306">
          <img src={MOCKUP_IMAGE} alt="Ebook Libres de Ser" loading="eager" decoding="async" width={520} height={520} className="w-full max-w-[340px] rounded-3xl shadow-soft sm:max-w-[400px]" data-id="element-65" data-mp="382p4rap7j9k3" />
        </div>
      </div>
    </header>;
}